export default {
  name: 'fake-countdown-time',
  props: ['hotlineDestinationNumber', 'widgetStyle'],
  data() {
    return {
      countdown: 17,
      showPie: true,
      timeDescription: 'sekund',
    };
  },
  mounted() {
    setInterval(() => {
      if (this.countdown <= 0) {
        this.countdown = 0;
        this.showPie = false;
      } else {
        this.countdown -= 1;
        this.timeDescription = [4, 3, 2].includes(this.countdown) ? 'sekundy' : 'sekund';
      }
    }, 1000);
  },
  computed: {
    pieBorder() {
      return {
        borderColor: this.widgetStyle.main_color,
      };
    },
    background() {
      return {
        background: this.widgetStyle.main_color,
      };
    },
  },
};
